<template>
    <div>
        <div class="columns is-centered">
            <div class="column is-three-quarters-tablet is-two-thirds-desktop is-three-fifths-widescreen is-three-fifths-fullhd border">
                <p class="contact-info">
                    Indien u bijkomende vragen heeft of indien u meer informatie wenst over het ras of een pup,
                    twijfel dan niet om ons te contacteren via onderstaand formulier. Wij helpen u graag verder.
                </p>
                <br />
                <form action="/send-contact" method="post">
                  <div class="field">
                    <div class="control has-icons-right">
                        <input name="name" class="input is-large" type="text" placeholder="Naam" value="" v-model="name" required>
                        <span class="icon is-small is-right">
                          <invalid-input v-if="!isValidName" class="invalid-input"></invalid-input>
                          <valid-input v-if="isValidName" class="valid-input"></valid-input>
                        </span>
                    </div>
                    <div class="control has-icons-right">
                        <input name="email" class="input is-large" type="text" placeholder="E-mail" value="" v-model="email" required>
                        <span class="icon is-small is-right">
                          <invalid-input v-if="!isValidEmail" class="invalid-input"></invalid-input>
                          <valid-input v-if="isValidEmail" class="valid-input"></valid-input>
                        </span>
                    </div>
                    <div class="control">
                        <input name="phone" class="input is-large" type="text" placeholder="Telefoon" value="">
                    </div>
                    <div class="control has-icons-right">
                      <input name="place" class="input is-large" type="text" placeholder="Woonplaats" value="" v-model="place" required>
                        <span class="icon is-small is-right">
                          <invalid-input v-if="!isValidPlace" class="invalid-input"></invalid-input>
                          <valid-input v-if="isValidPlace" class="valid-input"></valid-input>
                        </span>
                    </div>
                    <div class="control has-icons-right">
                        <input name="subject" class="input is-large" type="text" placeholder="Onderwerp" value="" v-model="subject" required>
                        <span class="icon is-small is-right">
                          <invalid-input v-if="!isValidSubject" class="invalid-input"></invalid-input>
                          <valid-input v-if="isValidSubject" class="valid-input"></valid-input>
                        </span>
                    </div>
                    <div class="control">
                        <textarea name="body" class="textarea is-medium" placeholder="Bericht" required></textarea>
                    </div>
                    <div class="data-policy">Uw gegevens worden enkel gebruikt door ons om u te contacteren. Wij geven nooit gegevens door aan derden.</div>
                    <div class="control btn">
                        <button type="submit" class="button is-primary" :disabled="isValidForm">Verzenden</button>
                    </div>
                  </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import InvalidInput from "vue-material-design-icons/AlertCircleOutline.vue";
import ValidInput from "vue-material-design-icons/CheckCircleOutline.vue";
    export default {
        name: "Contact",
        components: {
          InvalidInput, ValidInput
        },
        data: function () {
          return {
            name: "",
            email: "",
            place: "",
            subject: ""
          }
        },
        computed: {
          isValidName: function() {
            if (this.name.length > 2) {
              return true;
            } else {
              return false;
            }
          },
          isValidEmail: function() {
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
              return true;
            } else {
              return false;
            }
          },
          isValidPlace: function() {
            if (this.place.length > 2) {
              return true;
            } else {
              return false;
            }
          },
          isValidSubject: function() {
            if (this.subject.length > 4) {
              return true;
            } else {
              return false;
            }
          },
          isValidForm: function () {
            return !(this.isValidName && this.isValidEmail && this.isValidPlace && this.isValidSubject);
          }
        }
    }
</script>

<style scoped>
    .material-design-icon.invalid-input {
      /* font-size: 1rem; */
      color: #700100;
    }
    .material-design-icon.valid-input {
      /* font-size: 1rem; */
      color: #007001;
    }
    .input-slot {
      display: flex;
      flex-direction: row;
    }
    .required {
      color: #700100;
    }
    .control input[type=text],
    textarea {
        border: none;
        border-bottom: 2px solid #006f70;
        border-radius: 0;

        background: none;
        color: #006f70;
        box-shadow: none;

        font-family: "Poppins";
        font-size: 26px;

        margin-bottom: 20px;
        transition: color 1s ease, border 1s ease;
        padding-bottom: 0px;
    }

    .control input[type=text]::placeholder,
    textarea::placeholder {
        color: #006f70;
        font-size: 26px;
    }

    .control input[type=text]:focus,
    textarea:focus {
        color: #fff;
        outline: none;
        box-shadow: none;
        border-bottom: 2px solid #fff;
    }
    
    textarea {
        resize: none;
    }
/*
    textarea:hover {
        border-bottom-color: #fff;
    }
*/
    .btn {
        display: flex;
        flex-direction: column;
        align-content: center;
    }
    button.is-primary, button.is-primary:disabled {
        margin: 5vh auto 3vh auto;
        color: #f5f5f5;
        border-radius: 0;
        background-color: #1d7d7e;
        font-family: "Poppins";
        font-weight: 400;
        font-size: 1.3em;
        transition: color .3s ease, background-color .3s ease;
    }
    button.is-primary:hover {
        background-color: #f5f5f5;
        color: #016F70;
    }
    .data-policy {
      font-size: .8rem;
    }
    
    @media screen and (max-width: 768px) {
        button.is-primary {
            margin: 3vh auto 3vh auto;
        }
    }
</style>